import { get } from 'lodash';

export const MealPlanDayCalories = {
  bindings: {
    day: '<',
    meals: '<',
    recipes: '<',
  },

  template: `{{ $ctrl.calories }} Cal`,

  controller() {
    'ngInject';

    return {
      $onChanges(changes) {
        this.calories = this.calculateCalories(
          this.day.meals,
          this.meals,
          this.recipes
        );
      },

      calculateCalories(mealIds = [], meals = {}, recipes = {}) {
        return mealIds.reduce((sum, mealId) => {
          const recipe = recipes[meals[mealId].recipeId];
          return sum + ((recipe && recipe.caloriesPerServe) || 0);
        }, 0);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanDayCalories.js